
import React, { useState } from 'react';

import FSIndex from "@dndComponents/FSIndex";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import { Button } from '@mui/material';
import ConditionManager from "@dndViews/condition/ConditionManager";

export default function ConditionIndex() {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <>
        <ModalOrDrawer
          open={open}
          width={800}
          onClose={() => { setOpen(false); }}>
          <ConditionManager />
        </ModalOrDrawer>
      </>
    );
  }

  return (
    <>
      <FSIndex
        data_type="condition"
        quick_fields={["common"]}
        extra_by_add={() => {
          // debugger;
          return (
            <>
              <Button
                variant="contained" color="primary" 
                onClick={() => {
                  setOpen(true);
                }}>
                Condition Manager
              </Button>
            </>
          );
        }}
      />
      { renderExtras() }
    </>
  );
}
